import React, { useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { Button } from '../../../components/atoms/Button';
import { ButtonGroup } from '../../../components/molecules/ButtonGroup';
import { StickyButtons } from '../../../components/molecules/StickyButtons';
import { ReEngagementForm } from '../ReEngagementForm';
import { MultiForm } from '../../../components/organisms/MultiForm';
import { ThankYou } from '../../ThankYou';

import api from '../../../lib/api';

/**
 * Primary UI component for user interaction
 */
export const EmailAlreadyExists = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const initialValues = useMemo(() => {
    const values = {};

    // populate client first and last name
    ['first_name', 'last_name'].forEach((key) => {
      if (location?.state?.client?.[key]) {
        values[key] = location?.state?.client?.[key];
      }
    });

    return values;
  }, [location?.state?.client?.first_name, location?.state?.client?.last_name]);

  return (
    <MultiForm
      name="reEngagementForm"
      onSubmit={() => {}}
      hideButtons={true}
      initialHistory={[0]}
      ignoreStoredHistory={true}
      ignoreStoredValues={true}
      initialValues={initialValues}
    >
      <MultiForm.Page next={(values, step, nextPage) => {
        api.submitReEngagementRequest(values, (err, res) => {
          if (err || res?.data !== 'ok') {
            alert('Something went wrong. Please try again');

            return;
          }

          nextPage(values, step);
        });
      }}>
        <ReEngagementForm customButtons={
          <StickyButtons>
            <ButtonGroup isStacked classes='mx-auto' buttons={[
              <Button label="Submit" mode="primary" key={2} isSubmit />
            ]} />
          </StickyButtons>
        }/>
      </MultiForm.Page>

      <MultiForm.Page next={(values, step, nextPage) => {
        nextPage(values, step -2);
      }}>
        <ThankYou
          imageSrc=''
          title="Thank you, we will be in touch!"
          description="We've received your details and a member of our team will be in touch!"
          buttonLabel='Back To Home'
          onClick={() => window.location = 'https://www.livewelldorset.co.uk/'}
        />
      </MultiForm.Page>
    </MultiForm>
  );
};
